<template>
  <div class="dashboard-container after-loop">
    <h3>Dashboard <span>({{ aStatusLabel }})</span></h3>
    <p>Welcome {{ user.currentUser.name }}</p>
    <el-row :gutter="12">
      <el-col :xs="24" :sm="12" :md="12" :lg="6">
        <el-tooltip class="item apply-tooltip" effect="dark" content="Click to view" placement="top">
          <router-link to="#" class="after-loop-item card border-0 card-guides shadow-lg">
            <div class="card-body d-flex align-items-end flex-column text-right">
              <h1> {{ data.permanent }} </h1>
              <p class="w-75">Permanent Staff</p>
              <span class="i-icon"><i class="fas fa-user-tie"/></span>
            </div>
          </router-link>
        </el-tooltip>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6">
        <el-tooltip class="item apply-tooltip" effect="dark" content="Click to view" placement="top">
          <router-link to="#" class="after-loop-item card border-0 card-guides shadow-lg">
            <div class="card-body d-flex align-items-end flex-column text-right">
              <h1> {{ data.substitute }} </h1>
              <p class="w-75">Substitute Staff</p>
              <span class="i-icon"><i class="fas fa-user-tie"/></span>
            </div>
          </router-link>
        </el-tooltip>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6">
        <el-tooltip class="item apply-tooltip" effect="dark" content="Click to view" placement="top">
          <router-link to="#" class="after-loop-item card border-0 card-guides shadow-lg">
            <div class="card-body d-flex align-items-end flex-column text-right">
              <h1>{{ data.temporary }} </h1>
              <p class="w-75">Temporary Staff</p>
              <span class="i-icon"><i class="fas fa-user-graduate"/></span>
            </div>
          </router-link>
        </el-tooltip>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6">
        <el-tooltip class="item apply-tooltip" effect="dark" content="Click to view" placement="top">
          <router-link to="#" class="after-loop-item card border-0 card-guides shadow-lg">
            <div class="card-body d-flex align-items-end flex-column text-right">
              <h1>{{ data.scholar }} </h1>
              <p class="w-75">Scholar Staff</p>
              <span class="i-icon"><i class="fas fa-user-graduate"/></span>
            </div>
          </router-link>
        </el-tooltip>
      </el-col>
    </el-row>
    <el-row :gutter="12">
      <el-col :xs="24" :sm="12" :md="12" :lg="6">
        <el-tooltip class="item apply-tooltip" effect="dark" content="Click to view" placement="top">
          <router-link to="#" class="after-loop-item card border-0 card-guides shadow-lg">
            <div class="card-body d-flex align-items-end flex-column text-right">
              <h1> {{ data.active }} </h1>
              <p class="w-75">Payroll's Active Personnel</p>
              <span class="i-icon"><i class="fas fa-users"/></span>
            </div>
          </router-link>
        </el-tooltip>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6">
        <el-tooltip class="item apply-tooltip" effect="dark" content="Click to view" placement="top">
          <router-link to="#" class="after-loop-item card border-0 card-guides shadow-lg">
            <div class="card-body d-flex align-items-end flex-column text-right">
              <h1> {{ data.new }} </h1>
              <p class="w-75">New Personnel</p>
              <span class="i-icon"><i class="fas fa-user-plus"/></span>
            </div>
          </router-link>
        </el-tooltip>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Personnel } from '../../api/payroll/personnel'
import { setSelectedAPStatus } from '@/utils/appionmentStatus'
export default {
  name: 'Dashboard',
  data() {
    return {
      data: {
        permanent: 0,
        active: 0,
        scholar: 0,
        contractual: 0,
        temporary: 0,
        substitute: 0,
        casual: 0,
        promoted: 0,
        new: 0,
        updated: 0
      },
      meta: {},
      isRSPMeber: false,
      isUser: false,
      aStatus: parseInt(this.$route.params.status),
      aStatusLabel: null
    }
  },
  computed: {
    ...mapGetters([
      'username',
      'firstname',
      'lastname',
      'user'
    ])
  },
  created() {
    this.getAll()
  },
  methods: {
    getAll() {
      setSelectedAPStatus(this.aStatus)
      this.$store.dispatch('APStatus', this.aStatus)
      if (this.aStatus === 3) { this.aStatusLabel = 'Permanent' }
      if (this.aStatus === 2) { this.aStatusLabel = 'Contractual' }
      if (this.aStatus === 1) { this.aStatusLabel = 'Casual' }
      // console.log(this.$store.getters.APStatus)
      Personnel({}, 'get', 'analytics').then(res => {
        this.data.active = res.data.analytics.active[0].active
        this.data.permanent = res.data.analytics.permanent[0].permanent
        this.data.scholar = res.data.analytics.scholar[0].scholars
        this.data.contractual = res.data.analytics.contractual[0].contractual
        this.data.temporary = res.data.analytics.temporary[0].temporary
        this.data.substitute = res.data.analytics.substitute[0].substitute
        this.data.casual = res.data.analytics.casual[0].casual
        this.data.new = res.data.analytics.new[0].new
        this.data.updated = res.data.analytics.updated[0].updated
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  &-container {
    margin-right: 10px;
    margin-left: 10px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
@import '../../styles/z-theme.css';

.i-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 4rem;
  left: 1rem;
  color: rgba(255,255,255,.2);
  transition: .15s all ease;
}
.after-loop .card {
  margin-bottom: 10px;
}
.dark-green-bg{
  background-color: #136d27 !important;
}
</style>
